module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_2_2.65027d4d.jpeg";